module.exports = __webpack_public_path__ + "static/media/download_img_5.117aa16d.jpg";